// The Documents page shows firm-level files (no measurement date) as one extra
// accordion row, "Firm Documents". It stands in for a measurement date with
// this id, and its user-editable folders carry it as their md_documents, so the
// existing tree, selection and folder actions work unchanged; only the API
// calls branch on it. Negative, so it can never collide with a real id.
export const FIRM_LEVEL_DOCUMENTS_ID = -1;

// ?date= value that selects the Firm Documents row.
export const FIRM_LEVEL_DOCUMENTS_QUERY_VALUE = 'firm-documents';

export const FIRM_LEVEL_DOCUMENTS_LABEL = 'Firm Documents';

export const isFirmLevelDocumentsId = (id?: number | null) => id === FIRM_LEVEL_DOCUMENTS_ID;
